/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Use_Local_StorageInputs */



/**
* | output |
* | --- |
* | "Use Local Storage" |
*
* @param {Use_Local_StorageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const use_local_storage = /** @type {((inputs?: Use_Local_StorageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Use_Local_StorageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Utiliser le stockage local")
	if (locale === "de") return /** @type {LocalizedString} */ ("Lokalen Speicher verwenden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Utilizza l'archiviazione locale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Использовать локальное хранилище")
	if (locale === "es") return /** @type {LocalizedString} */ ("Usar almacenamiento local")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("使用本地存储")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ローカルストレージを使用する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्थानीय संग्रहण का उपयोग करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Usar armazenamento local")
	return /** @type {LocalizedString} */ ("Use Local Storage")
});